import React, { FC } from 'react';
import { MarkdownImageProps } from './props';
import './styles.scss';

export const MarkdownImage: FC<MarkdownImageProps> = ({ alt, src }) => {
  if (src.includes('twemoji')) {
    return <img alt={alt} className="markdown-image" src={src} />;
  }

  return null;
};
